import { Center } from "@mantine/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "./icon.module.scss";
import type { IProps } from "./icon.types";
import { forwardRef } from "react";
import classnames from "classnames";

const Icon = forwardRef<HTMLDivElement, IProps>(function Icon({ size, className, ...props }, ref) {
    return (
        <Center ref={ref}>
            <FontAwesomeIcon fixedWidth data-size={size} className={classnames(styles["icon"], className)} {...props} />
        </Center>
    );
});

export { Icon };
